export default class ShareLink {
    constructor () {
        this.shareLink = document.querySelectorAll('[data-share="link"]')

        // If there's no share link buttons, return
        if (!this.shareLink)
            return

        this.shareLink.forEach(btn => this.watch(btn))
    }

    watch (el) {
        let timeout = null
        const successCss = 'share-item-link-success'

        el.addEventListener('click', () => {
            clearTimeout(timeout)
            el.classList.add(successCss)

            if (el.dataset.link)
                navigator.clipboard.writeText(el.dataset.link)
            else
                navigator.clipboard.writeText(window.location.href)

            timeout = setTimeout(() => {
                el.classList.remove(successCss)
            }, 3000)
        })
    }
}
